import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
  Rating,
  Divider,
  Tabs,
  Tab,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Business as VendorIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  AccountBalance as BankIcon,
  Receipt as GstIcon,
  CreditCard as PaymentIcon,
  Star as StarIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Person as PersonIcon,
  Description as DocumentIcon,
  LocalShipping as ShippingIcon,
  Inventory as ProductIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as MoneyIcon,
} from "@mui/icons-material";

const VendorSupplier = () => {
  const [vendorData, setVendorData] = useState([
    { 
      id: 1, 
      vendorCode: "VEN001",
      vendorName: "ABC Suppliers Pvt Ltd", 
      companyName: "ABC Suppliers Pvt Ltd",
      vendorType: "Manufacturer",
      contactPerson: "Rajesh Kumar",
      phone: "+91-9876543210",
      email: "rajesh@abcsuppliers.com",
      address: "123 Industrial Area, Phase-1, Mumbai",
      city: "Mumbai",
      state: "Maharashtra",
      pincode: "400001",
      country: "India",
      gstNumber: "27AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 30,
      paymentTerms: "Net 30",
      bankName: "HDFC Bank",
      accountNumber: "50200012345678",
      ifscCode: "HDFC0001234",
      productCategory: "Electronics",
      rating: 4.5,
      totalOrders: 156,
      totalAmount: 2450000,
      status: "Active",
      isVerified: true,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 2, 
      vendorCode: "VEN002",
      vendorName: "XYZ Wholesale", 
      companyName: "XYZ Wholesale Trading Co.",
      vendorType: "Distributor",
      contactPerson: "Priya Sharma",
      phone: "+91-9876543211",
      email: "priya@xyzwholesale.com",
      address: "456 Market Road, Delhi",
      city: "New Delhi",
      state: "Delhi",
      pincode: "110001",
      country: "India",
      gstNumber: "07AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 45,
      paymentTerms: "Net 45",
      bankName: "ICICI Bank",
      accountNumber: "60300012345678",
      ifscCode: "ICIC0001234",
      productCategory: "Clothing",
      rating: 4.2,
      totalOrders: 89,
      totalAmount: 1230000,
      status: "Active",
      isVerified: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    { 
      id: 3, 
      vendorCode: "VEN003",
      vendorName: "Global Imports LLC", 
      companyName: "Global Imports LLC",
      vendorType: "Importer",
      contactPerson: "John Smith",
      phone: "+91-9876543212",
      email: "john@globalimports.com",
      address: "789 Export House, Bangalore",
      city: "Bangalore",
      state: "Karnataka",
      pincode: "560001",
      country: "India",
      gstNumber: "29AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 60,
      paymentTerms: "Net 60",
      bankName: "SBI",
      accountNumber: "70400012345678",
      ifscCode: "SBIN0001234",
      productCategory: "Home Appliances",
      rating: 4.8,
      totalOrders: 234,
      totalAmount: 5670000,
      status: "Active",
      isVerified: true,
      createdDate: "2023-12-01",
      updatedDate: "2023-12-01"
    },
    { 
      id: 4, 
      vendorCode: "VEN004",
      vendorName: "Local Traders", 
      companyName: "Local Traders",
      vendorType: "Retailer",
      contactPerson: "Amit Patel",
      phone: "+91-9876543213",
      email: "amit@localtraders.com",
      address: "321 Gandhi Road, Ahmedabad",
      city: "Ahmedabad",
      state: "Gujarat",
      pincode: "380001",
      country: "India",
      gstNumber: "24AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 15,
      paymentTerms: "Net 15",
      bankName: "Axis Bank",
      accountNumber: "80500012345678",
      ifscCode: "UTIB0001234",
      productCategory: "Groceries",
      rating: 3.8,
      totalOrders: 67,
      totalAmount: 890000,
      status: "Active",
      isVerified: false,
      createdDate: "2024-02-01",
      updatedDate: "2024-02-01"
    },
    { 
      id: 5, 
      vendorCode: "VEN005",
      vendorName: "Premium Products Inc", 
      companyName: "Premium Products Inc",
      vendorType: "Manufacturer",
      contactPerson: "Sarah Johnson",
      phone: "+91-9876543214",
      email: "sarah@premiumproducts.com",
      address: "555 Industrial Zone, Pune",
      city: "Pune",
      state: "Maharashtra",
      pincode: "411001",
      country: "India",
      gstNumber: "27AABCU9603R1ZN",
      panNumber: "AABCU9603R",
      creditDays: 30,
      paymentTerms: "Net 30",
      bankName: "HDFC Bank",
      accountNumber: "90600012345678",
      ifscCode: "HDFC0001235",
      productCategory: "Furniture",
      rating: 4.6,
      totalOrders: 123,
      totalAmount: 3450000,
      status: "Active",
      isVerified: true,
      createdDate: "2024-01-10",
      updatedDate: "2024-01-10"
    },
    { 
      id: 6, 
      vendorCode: "VEN006",
      vendorName: "Quick Supply Co", 
      companyName: "Quick Supply Co",
      vendorType: "Distributor",
      contactPerson: "Mohammed Ali",
      phone: "+91-9876543215",
      email: "ali@quicksupply.com",
      address: "888 Trade Center, Hyderabad",
      city: "Hyderabad",
      state: "Telangana",
      pincode: "500001",
      country: "India",
      gstNumber: "36AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 20,
      paymentTerms: "Net 20",
      bankName: "ICICI Bank",
      accountNumber: "10700012345678",
      ifscCode: "ICIC0001235",
      productCategory: "Stationery",
      rating: 4.0,
      totalOrders: 98,
      totalAmount: 1560000,
      status: "Active",
      isVerified: true,
      createdDate: "2024-01-20",
      updatedDate: "2024-01-20"
    },
    { 
      id: 7, 
      vendorCode: "VEN007",
      vendorName: "Tech Solutions Pvt Ltd", 
      companyName: "Tech Solutions Pvt Ltd",
      vendorType: "Manufacturer",
      contactPerson: "Vikram Singh",
      phone: "+91-9876543216",
      email: "vikram@techsolutions.com",
      address: "999 Tech Park, Chennai",
      city: "Chennai",
      state: "Tamil Nadu",
      pincode: "600001",
      country: "India",
      gstNumber: "33AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 45,
      paymentTerms: "Net 45",
      bankName: "SBI",
      accountNumber: "11800012345678",
      ifscCode: "SBIN0001235",
      productCategory: "Electronics",
      rating: 4.7,
      totalOrders: 187,
      totalAmount: 4230000,
      status: "Active",
      isVerified: true,
      createdDate: "2023-11-15",
      updatedDate: "2023-11-15"
    },
    { 
      id: 8, 
      vendorCode: "VEN008",
      vendorName: "Express Logistics", 
      companyName: "Express Logistics Services",
      vendorType: "Logistics",
      contactPerson: "Neha Gupta",
      phone: "+91-9876543217",
      email: "neha@expresslogistics.com",
      address: "111 Transport Nagar, Jaipur",
      city: "Jaipur",
      state: "Rajasthan",
      pincode: "302001",
      country: "India",
      gstNumber: "08AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 7,
      paymentTerms: "Net 7",
      bankName: "Axis Bank",
      accountNumber: "12900012345678",
      ifscCode: "UTIB0001235",
      productCategory: "Services",
      rating: 4.3,
      totalOrders: 456,
      totalAmount: 890000,
      status: "Active",
      isVerified: true,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 9, 
      vendorCode: "VEN009",
      vendorName: "Budget Suppliers", 
      companyName: "Budget Suppliers",
      vendorType: "Wholesaler",
      contactPerson: "Ramesh Verma",
      phone: "+91-9876543218",
      email: "ramesh@budgetsuppliers.com",
      address: "222 Wholesale Market, Kolkata",
      city: "Kolkata",
      state: "West Bengal",
      pincode: "700001",
      country: "India",
      gstNumber: "19AABCU9603R1ZM",
      panNumber: "AABCU9603R",
      creditDays: 10,
      paymentTerms: "Net 10",
      bankName: "HDFC Bank",
      accountNumber: "13000012345678",
      ifscCode: "HDFC0001236",
      productCategory: "Groceries",
      rating: 3.5,
      totalOrders: 234,
      totalAmount: 1120000,
      status: "Inactive",
      isVerified: false,
      createdDate: "2024-02-15",
      updatedDate: "2024-02-15"
    },
    { 
      id: 10, 
      vendorCode: "VEN010",
      vendorName: "Quality Foods Ltd", 
      companyName: "Quality Foods Limited",
      vendorType: "Manufacturer",
      contactPerson: "Sunita Reddy",
      phone: "+91-9876543219",
      email: "sunita@qualityfoods.com",
      address: "333 Food Park, Coimbatore",
      city: "Coimbatore",
      state: "Tamil Nadu",
      pincode: "641001",
      country: "India",
      gstNumber: "33AABCU9603R1ZN",
      panNumber: "AABCU9603R",
      creditDays: 30,
      paymentTerms: "Net 30",
      bankName: "SBI",
      accountNumber: "14100012345678",
      ifscCode: "SBIN0001236",
      productCategory: "Food & Beverages",
      rating: 4.4,
      totalOrders: 298,
      totalAmount: 2890000,
      status: "Active",
      isVerified: true,
      createdDate: "2023-12-20",
      updatedDate: "2023-12-20"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [verifiedFilter, setVerifiedFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [tabValue, setTabValue] = useState(0);

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingVendor, setEditingVendor] = useState(null);
  const [viewingVendor, setViewingVendor] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newVendor, setNewVendor] = useState({
    vendorCode: "",
    vendorName: "",
    companyName: "",
    vendorType: "Manufacturer",
    contactPerson: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
    gstNumber: "",
    panNumber: "",
    creditDays: 30,
    paymentTerms: "Net 30",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    productCategory: "",
    status: "Active",
    isVerified: false,
  });

  // Get unique values for filters
  const vendorTypes = [...new Set(vendorData.map(v => v.vendorType))];
  const productCategories = [...new Set(vendorData.map(v => v.productCategory))];

  // Helper functions
  const getFilteredVendors = () => {
    return vendorData.filter((vendor) => {
      const matchesSearch = Object.values(vendor).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || vendor.status === statusFilter;
      const matchesType = typeFilter === "all" || vendor.vendorType === typeFilter;
      const matchesVerified = verifiedFilter === "all" || 
        (verifiedFilter === "verified" && vendor.isVerified) ||
        (verifiedFilter === "unverified" && !vendor.isVerified);
      return matchesSearch && matchesStatus && matchesType && matchesVerified;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Inactive':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      case 'Suspended':
        return { backgroundColor: '#fff3e0', color: '#e65100' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Manufacturer': return 'primary';
      case 'Distributor': return 'secondary';
      case 'Wholesaler': return 'success';
      case 'Retailer': return 'warning';
      case 'Importer': return 'info';
      case 'Logistics': return 'error';
      default: return 'default';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newVendor.vendorName.trim()) newErrors.vendorName = 'Vendor name is required';
    if (!newVendor.companyName.trim()) newErrors.companyName = 'Company name is required';
    if (!newVendor.contactPerson.trim()) newErrors.contactPerson = 'Contact person is required';
    if (!newVendor.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!newVendor.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(newVendor.email)) newErrors.email = 'Email is invalid';
    if (!newVendor.address.trim()) newErrors.address = 'Address is required';
    if (!newVendor.city.trim()) newErrors.city = 'City is required';
    if (!newVendor.state.trim()) newErrors.state = 'State is required';
    if (!newVendor.pincode.trim()) newErrors.pincode = 'Pincode is required';
    if (newVendor.gstNumber && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(newVendor.gstNumber)) {
      newErrors.gstNumber = 'Invalid GST format';
    }
    if (newVendor.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(newVendor.panNumber)) {
      newErrors.panNumber = 'Invalid PAN format';
    }
    return newErrors;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Handlers
  const handleEdit = (vendor) => {
    setEditingVendor(vendor);
    setNewVendor({ ...vendor });
    setOpenModal(true);
  };

  const handleView = (vendor) => {
    setViewingVendor(vendor);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const vendorToDelete = vendorData.find(v => v.id === id);
    
    if (vendorToDelete.totalOrders > 0) {
      if (!window.confirm(`This vendor has ${vendorToDelete.totalOrders} orders. Are you sure you want to delete?`)) {
        return;
      }
    }

    if (window.confirm("Are you sure you want to delete this vendor?")) {
      setVendorData(vendorData.filter((vendor) => vendor.id !== id));
      setSuccessMessage("Vendor deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredVendors().length} vendors.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setVerifiedFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingVendor(null);
    setNewVendor({
      vendorCode: "",
      vendorName: "",
      companyName: "",
      vendorType: "Manufacturer",
      contactPerson: "",
      phone: "",
      email: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      country: "India",
      gstNumber: "",
      panNumber: "",
      creditDays: 30,
      paymentTerms: "Net 30",
      bankName: "",
      accountNumber: "",
      ifscCode: "",
      productCategory: "",
      status: "Active",
      isVerified: false,
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingVendor(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingVendor(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setNewVendor({ 
      ...newVendor, 
      [name]: type === 'checkbox' ? checked : value 
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddVendor = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingVendor) {
        setVendorData(vendorData.map(vendor => 
          vendor.id === editingVendor.id 
            ? { 
                ...vendor, 
                ...newVendor,
                creditDays: parseInt(newVendor.creditDays),
                updatedDate: new Date().toISOString().split('T')[0]
              }
            : vendor
        ));
        setSuccessMessage("Vendor updated successfully!");
      } else {
        const newId = vendorData.length > 0 ? Math.max(...vendorData.map(v => v.id)) + 1 : 1;
        const vendorCode = `VEN${String(newId).padStart(3, '0')}`;
        setVendorData([...vendorData, { 
          id: newId, 
          ...newVendor,
          vendorCode: newVendor.vendorCode || vendorCode,
          creditDays: parseInt(newVendor.creditDays),
          rating: 0,
          totalOrders: 0,
          totalAmount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Vendor added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredVendors = getFilteredVendors();

  // Calculate statistics
  const totalVendors = vendorData.length;
  const activeVendors = vendorData.filter(v => v.status === "Active").length;
  const verifiedVendors = vendorData.filter(v => v.isVerified).length;
  const totalOrders = vendorData.reduce((sum, vendor) => sum + vendor.totalOrders, 0);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalVendors} color="primary">
            <VendorIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Vendor & Supplier Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage vendors, suppliers, and logistics partners • {filteredVendors.length} vendors found
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Add New Vendor
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Search Vendors..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Type"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Types</option>
              {vendorTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Verification"
              value={verifiedFilter}
              onChange={(e) => setVerifiedFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All</option>
              <option value="verified">Verified</option>
              <option value="unverified">Unverified</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Suspended">Suspended</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Vendor Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Contact Person</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>City/State</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Rating</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Verified</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredVendors.length > 0 ? (
                filteredVendors
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((vendor, index) => (
                    <TableRow 
                      key={vendor.id} 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600" sx={{ fontFamily: 'monospace' }}>
                          {vendor.vendorCode}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="600">
                            {vendor.vendorName}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {vendor.productCategory}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={vendor.vendorType} 
                          size="small" 
                          color={getTypeColor(vendor.vendorType)}
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <PersonIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                          <Typography variant="body2">
                            {vendor.contactPerson}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
                          {vendor.phone}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="500">
                            {vendor.city}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {vendor.state}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Rating value={vendor.rating} precision={0.1} size="small" readOnly />
                          <Typography variant="caption" fontWeight="600">
                            {vendor.rating}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        {vendor.isVerified ? (
                          <CheckCircleIcon sx={{ color: 'success.main', fontSize: 24 }} />
                        ) : (
                          <CancelIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={vendor.status}
                          size="small"
                          sx={{
                            ...getStatusStyle(vendor.status),
                            fontWeight: 600,
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(vendor)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'info.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Vendor">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(vendor)}
                              sx={{
                                color: 'warning.main',
                                '&:hover': {
                                  backgroundColor: 'warning.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Vendor">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(vendor.id)}
                              sx={{
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                    <VendorIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">
                      No vendors found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Try adjusting your search criteria or add a new vendor.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredVendors.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Add/Edit Vendor Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="lg" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <VendorIcon />
            {editingVendor ? 'Edit Vendor' : 'Add New Vendor'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} sx={{ mb: 3 }}>
            <Tab label="Basic Information" />
            <Tab label="Contact & Address" />
            <Tab label="Business Details" />
            <Tab label="Payment & Banking" />
          </Tabs>

          {/* Tab 0: Basic Information */}
          {tabValue === 0 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Vendor Code"
                  name="vendorCode"
                  value={newVendor.vendorCode}
                  onChange={handleInputChange}
                  helperText="Auto-generated if left empty"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Vendor/Supplier Name"
                  name="vendorName"
                  value={newVendor.vendorName}
                  onChange={handleInputChange}
                  error={!!errors.vendorName}
                  helperText={errors.vendorName}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Name"
                  name="companyName"
                  value={newVendor.companyName}
                  onChange={handleInputChange}
                  error={!!errors.companyName}
                  helperText={errors.companyName}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth error={!!errors.vendorType}>
                  <InputLabel>Vendor Type *</InputLabel>
                  <Select
                    name="vendorType"
                    value={newVendor.vendorType}
                    onChange={handleInputChange}
                    label="Vendor Type *"
                  >
                    <MenuItem value="Manufacturer">Manufacturer</MenuItem>
                    <MenuItem value="Distributor">Distributor</MenuItem>
                    <MenuItem value="Wholesaler">Wholesaler</MenuItem>
                    <MenuItem value="Retailer">Retailer</MenuItem>
                    <MenuItem value="Importer">Importer</MenuItem>
                    <MenuItem value="Logistics">Logistics Partner</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Product Category"
                  name="productCategory"
                  value={newVendor.productCategory}
                  onChange={handleInputChange}
                  placeholder="e.g., Electronics, Clothing, Groceries"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="status"
                    value={newVendor.status}
                    onChange={handleInputChange}
                    label="Status"
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="Suspended">Suspended</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={newVendor.isVerified}
                      onChange={handleInputChange}
                      name="isVerified"
                      color="success"
                    />
                  }
                  label="Verified Vendor"
                />
              </Grid>
            </Grid>
          )}

          {/* Tab 1: Contact & Address */}
          {tabValue === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Contact Person"
                  name="contactPerson"
                  value={newVendor.contactPerson}
                  onChange={handleInputChange}
                  error={!!errors.contactPerson}
                  helperText={errors.contactPerson}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  name="phone"
                  value={newVendor.phone}
                  onChange={handleInputChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email Address"
                  name="email"
                  type="email"
                  value={newVendor.email}
                  onChange={handleInputChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={newVendor.address}
                  onChange={handleInputChange}
                  error={!!errors.address}
                  helperText={errors.address}
                  required
                  multiline
                  rows={2}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="City"
                  name="city"
                  value={newVendor.city}
                  onChange={handleInputChange}
                  error={!!errors.city}
                  helperText={errors.city}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="State"
                  name="state"
                  value={newVendor.state}
                  onChange={handleInputChange}
                  error={!!errors.state}
                  helperText={errors.state}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  value={newVendor.pincode}
                  onChange={handleInputChange}
                  error={!!errors.pincode}
                  helperText={errors.pincode}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Country"
                  name="country"
                  value={newVendor.country}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
          )}

          {/* Tab 2: Business Details */}
          {tabValue === 2 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="GST Number"
                  name="gstNumber"
                  value={newVendor.gstNumber}
                  onChange={handleInputChange}
                  error={!!errors.gstNumber}
                  helperText={errors.gstNumber || "Format: 27AABCU9603R1ZM"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <GstIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="PAN Number"
                  name="panNumber"
                  value={newVendor.panNumber}
                  onChange={handleInputChange}
                  error={!!errors.panNumber}
                  helperText={errors.panNumber || "Format: AABCU9603R"}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DocumentIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Credit Days"
                  name="creditDays"
                  type="number"
                  value={newVendor.creditDays}
                  onChange={handleInputChange}
                  helperText="Number of days for payment"
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Payment Terms"
                  name="paymentTerms"
                  value={newVendor.paymentTerms}
                  onChange={handleInputChange}
                  placeholder="e.g., Net 30, Net 45"
                />
              </Grid>
            </Grid>
          )}

          {/* Tab 3: Payment & Banking */}
          {tabValue === 3 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bank Name"
                  name="bankName"
                  value={newVendor.bankName}
                  onChange={handleInputChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <BankIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Account Number"
                  name="accountNumber"
                  value={newVendor.accountNumber}
                  onChange={handleInputChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PaymentIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="IFSC Code"
                  name="ifscCode"
                  value={newVendor.ifscCode}
                  onChange={handleInputChange}
                  placeholder="e.g., HDFC0001234"
                />
              </Grid>
            </Grid>
          )}

          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddVendor}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingVendor ? 'Update Vendor' : 'Add Vendor')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Vendor Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Vendor Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingVendor && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar 
                    sx={{ 
                      width: 80, 
                      height: 80, 
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <VendorIcon sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 2 }}>
                    <Typography variant="h5" fontWeight="bold">
                      {viewingVendor.vendorName}
                    </Typography>
                    {viewingVendor.isVerified && (
                      <CheckCircleIcon sx={{ color: 'success.main', fontSize: 28 }} />
                    )}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {viewingVendor.vendorCode} • {viewingVendor.companyName}
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingVendor.vendorType} 
                      color={getTypeColor(viewingVendor.vendorType)}
                      sx={{ mr: 1 }}
                    />
                    <Chip
                      label={viewingVendor.status}
                      sx={{
                        ...getStatusStyle(viewingVendor.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Divider><Typography variant="caption" color="text.secondary">CONTACT INFORMATION</Typography></Divider>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Contact Person</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <PersonIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingVendor.contactPerson}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Phone Number</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <PhoneIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingVendor.phone}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Email Address</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <EmailIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold" sx={{ wordBreak: 'break-all' }}>
                      {viewingVendor.email}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Location</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <LocationIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingVendor.city}, {viewingVendor.state}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Divider><Typography variant="caption" color="text.secondary">BUSINESS DETAILS</Typography></Divider>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Product Category</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                    {viewingVendor.productCategory}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">GST Number</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1, fontFamily: 'monospace' }}>
                    {viewingVendor.gstNumber}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">PAN Number</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1, fontFamily: 'monospace' }}>
                    {viewingVendor.panNumber}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Payment Terms</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                    {viewingVendor.paymentTerms} ({viewingVendor.creditDays} days)
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Divider><Typography variant="caption" color="text.secondary">BANKING INFORMATION</Typography></Divider>
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Bank Name</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                    {viewingVendor.bankName}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Account Number</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1, fontFamily: 'monospace' }}>
                    {viewingVendor.accountNumber}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">IFSC Code</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ mt: 1, fontFamily: 'monospace' }}>
                    {viewingVendor.ifscCode}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Divider><Typography variant="caption" color="text.secondary">PERFORMANCE METRICS</Typography></Divider>
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)', textAlign: 'center' }}>
                  <Typography variant="caption" color="text.secondary">Rating</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Rating value={viewingVendor.rating} precision={0.1} readOnly />
                    <Typography variant="h6" fontWeight="bold" color="warning.main">
                      {viewingVendor.rating} / 5
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)', textAlign: 'center' }}>
                  <Typography variant="caption" color="text.secondary">Total Orders</Typography>
                  <Typography variant="h5" fontWeight="bold" color="primary.main" sx={{ mt: 1 }}>
                    {viewingVendor.totalOrders}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)', textAlign: 'center' }}>
                  <Typography variant="caption" color="text.secondary">Total Business</Typography>
                  <Typography variant="h6" fontWeight="bold" color="success.main" sx={{ mt: 1 }}>
                    {formatCurrency(viewingVendor.totalAmount)}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingVendor && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingVendor);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Vendor
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VendorSupplier;

